export enum TradeType {

    MarketOrder = 1,
    EntryOrder = 3
}
